const encode = (value) => encodeURIComponent(String(value || ''));

export const labEndpoints = {
  login: (base) => `${base}/api/v1/auth/login/`,
  emailLookup: (base) => `${base}/api/v1/questionnaires/auth/check-email/`,
  onboarding: (base) => `${base}/api/patient/onboarding/`,
  patientProfile: (base) => `${base}/api/v1/medical/patients/update_profile/`,
  paymentMethods: (base) => `${base}/api/v1/labs/checkout/payment-methods/`,
  storefront: (base, slug) => `${base}/api/v1/labs/storefront/${encode(slug)}/`,
  policies: (base, slug) => `${base}/api/v1/labs/storefront/${encode(slug)}/policies/`,
  availability: (base, slug, query) =>
    `${base}/api/v1/labs/storefront/${encode(slug)}/availability/?${query}`,
  checkout: (base) => `${base}/api/v1/labs/checkout/`,
};
